<template>
  <b-container>
  <div id="quizframe" style="margin: 1rem 0 0 0;">
    <b-row>
      <b-col md="5" class="text-center">
       <div style="background:#d0d0d0;">
         <b-img-lazy v-bind="logoProps" :src="cover.logo"></b-img-lazy>
         <div class="showtitle">{{ cover.title }}</div>
         <div class="showdate">{{ cover.date }}</div>
         <div class="showhost">{{ cover.host }}</div>
       </div>
      </b-col>
      <b-col md="7">
       <b-row v-show="mode_qa()" class="text-center" >
          <b-col class="quiz_questnum" v-if="!use_tb && quest[quest_idx].num">
             Question {{ quest[quest_idx].num }} of {{ quest[quest_idx].max }}
          </b-col>
          <b-col class="quiz_questnum" v-if="use_tb && quest[quest_idx].num">
             Tie-Breaker {{ quest[quest_idx].num }} of {{ quest[quest_idx].max }}
          </b-col>
       </b-row>       
       <b-row v-show="mode_qa()" class="text-center" > 
          <b-col class="quiz_topic" v-if="!quest[quest_idx].worth || quest[quest_idx].worth == 1">
            {{ quest[quest_idx].t }}
          </b-col>
          <b-col v-if="quest[quest_idx].worth > 1">
            <span class="quiz_topic"> {{ quest[quest_idx].t }} </span>
            <span class="quiz_worth"> +{{ quest[quest_idx].worth }} </span>
          </b-col>
          <b-col v-if="qa_waiting() && quest[quest_idx].num && is_raise_allowed && qna_timer.val > 0 && qna_timer.val < 30">
            <div class="quiz_timer"> {{ qna_timer.val }} </div>
          </b-col>
          <b-col v-if="qa_waiting() && quest[quest_idx].num && (!is_raise_allowed || qna_timer.val <= 0)">
            <div class="quiz_timer" style="border:none;"> CLOSED </div>
          </b-col>
       </b-row>
       <b-row v-show="mode_qa() && !qa_none() && quest[quest_idx].q" >
          <div class="quiz_question"> {{ quest[quest_idx].q }}  </div>
       </b-row>
       <b-row v-if="mode_qa() && !qa_none() && quest[quest_idx].qi" >
          <b-img-lazy v-bind="qimgProps" class="quiz_questionimg" :src="quest[quest_idx].qi"></b-img-lazy>
       </b-row>
       <b-row v-show="mode_lb()" >
         <b-col class="leaderbd">
           <b-row class="text-center">
              <b-col class="leaderbd_title"> Leader Board </b-col>
           </b-row>
           <b-table striped show-empty stacked="md"
             :fields="scoreFields"
             :items="leaderboard"
             small>
             <template v-slot:cell(rank)="data">
               {{ (data.item.rank>0)?("#"+data.item.rank):"" }}
             </template>
             <template v-slot:cell(r)="data">
               <span style="color:green">{{ data.item.r }}</span>
             </template>
             <template v-slot:cell(w)="data">
               <span style="color:red">{{ data.item.w }}</span>
               <span class="leaderbdsub" style="color:red" v-if="data.item.wa">({{ data.item.wa }})</span>
             </template>
             <template v-slot:cell(score)="data">
               {{ (mastercfg.points*(data.item.r - data.item.w)) }}
             </template>
           </b-table>
         </b-col>
       </b-row>
       <b-row v-show="mode_rules()" >
         <b-col class="rules">
           <b-row class="text-center">
              <b-col class="rules_title"> Rules </b-col>
           </b-row>
           <b-table striped show-empty stacked="md" style="margin:0"
             :fields="qrulesFields"
             :items="qrules"
             small>
             <template v-slot:cell(n)="data">
               <span class="rules_num"> {{ "#"+data.item.n }} </span>
             </template>
             <template v-slot:cell(r)="data">
               <span class="rules_rule"> {{ data.item.r }} </span>
             </template>
           </b-table>
         </b-col>
       </b-row>
      </b-col>
    </b-row>
  </div>
  <div style="position:absolute; bottom:0; width:100%;">
    <b-row align-v="end" class="text-center">
      <b-col md="5" v-show="mode_lb()">
        <b-row>
          <b-button class="btn_score" size="sm"
            variant="outline-success" @click="do_raise_leaders()">
            Raise Leaders
          </b-button>
        </b-row>
        <b-row> LB <span class="shortcut">L</span>:return to quiz
        </b-row>
      </b-col>
      <b-col md="5" v-show="mode_qa()" >
       <b-row>
         <b-form-file v-show="quest_idx==0"
           v-model="cfgfile" size="sm" plain
           :state="Boolean(cfgfile)"
         ></b-form-file>
       </b-row>
       <b-row>
         <b-button size="sm" variant="primary"
          v-if="cfgfile && quest_idx==0"
          @click="loadCfg">
            Load
         </b-button>
       </b-row>
       <b-row>
        <b-button class="btn_score" size="sm"
          variant="outline-danger" @click="do_lower_hand_all()">
          Empty
        </b-button>
        <span style="font-size:1.7vh"> {{ quest[quest_idx].a }} </span>
        <b-table striped show-empty stacked="md"
         :fields="playerFields"
         :items="players"
         small>
          <template v-slot:cell(rank)="data">
             {{ (data.item.rank>0)?("#"+data.item.rank):"-" }}
          </template>
          <template v-slot:cell(ctrl)="data">
            <b-button class="btn_score" size="sm" v-show="!data.item.ans"
              variant="success" @click="qa_ans(data.item,true)">
              Correct
            </b-button>
            <b-button class="btn_score" size="sm" v-show="!data.item.ans"
              variant="danger" @click="qa_ans(data.item,false)">
              Wrong
            </b-button>
            <b-button class="btn_score" size="sm" v-show="data.item.ans>0"
              variant="outline-success">
              Answered Correct
            </b-button>
            <b-button class="btn_score" size="sm" v-show="data.item.ans<0"
              variant="outline-danger">
              Answered Wrong
            </b-button>
            <b-button class="btn_score" size="sm" v-show="data.item.ans"
              variant="secondary" @click="qa_ans_undo(data.item)">
              Undo
            </b-button>
            <b-button class="btn_score" size="sm" style="float:right"
              variant="outline-danger" @click="do_lower_hand(data.item)">
              L.H.
            </b-button>
          </template>
        </b-table>
       </b-row>
       <b-row> {{ qa_waiting()?"@2":"@3" }} <span class="shortcut">Q</span>:tie <span class="shortcut">L</span>:leader <span class="shortcut">R</span>:refr <span class="shortcut">X</span>:rule <span class="shortcut">0</span>:start
       </b-row>
      </b-col>
      <b-col md="7" v-show="mode_qa() && qa_done()" style="padding: 0 0 5rem 1rem;">
        <div v-if="!quest[quest_idx].ai" class="quiz_answer"> {{ quest[quest_idx].a }} </div>
        <div v-if="quest[quest_idx].ai" :style="{ backgroundImage: `url(${quest[quest_idx].ai})` }" class="quiz_answer quiz_answerimg"> {{ quest[quest_idx].a }} </div>
        <div class="quiz_note" v-show="quest[quest_idx].n" >
           ( {{ quest[quest_idx].n }} )
        </div>
      </b-col>
    </b-row>
  </div>
  </b-container>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";

export default {
  name: "quiz",
  data() {
    return {
      addlistener: true,
      logoProps:{center:true, fluid: true},      
      qimgProps:{center:true, fluid: true,},      
      mode:"qa",
      qa: "none",
      quest:[{q:"",qi:""}],
      use_tb:false,
      quest_idx:0,
      main_quest_idx:0,
      tb_quest_idx:0,
      scores: [],
      leaderboard: [],
      scoreFields: [
          { key: "rank", label: ""},
          { key: "d", label: "Player"},
          { key: "r", label: "Correct"},
          { key: "w", label: "Wrong"},
          { key: "score", label: "Score"},
      ],
      players:[],
      playerFields:[
          { key: "rank", label: ""},
          { key: "d", label: ""},
          { key: "ctrl", label: ""},
      ],
      qrules:[{n:1,r:"first rule"},{n:2,r:"second rule"},{n:3,r:"third rule"},{n:4,r:"fourth rule"}],
      qrulesFields:[
          { key: "n", label: ""},
          { key: "r", label: ""},
      ],
      cfgfile: null,
      mastercfg:{},
      cover:{title:"Title",date:"The Date",host:"Host Name",logo:""},
      is_raise_allowed: false,
      qna_timer: {tid:null, val:0},
    };
  },
  components: {
  },
  created() {
  },
  mounted() {
    //console.log("Mounted");
    this.init_page();
  },
  beforeDestroy() {
    //console.log("Destroy");
    let vue=this;
    window.wss_clr_routes(window.vx,"quiz");
    document.removeEventListener("keydown", vue.handle_keypress);
    vue.addlistener = true;
  },
  methods: {
     mode_qa: function() {
       return this.mode == "qa";
     },
     mode_lb: function() {
       return this.mode == "lb";
     },
     mode_rules: function() {
       return this.mode == "rules";
     },
     qa_waiting: function() {
       return this.qa == "waiting";
     },
     qa_done: function() {
       return this.qa == "done";
     },
     qa_none: function() {
       return !this.qa_waiting() && !this.qa_done();
     },
     refreshSelf: function() {
       vx_api.getSelf(window.vx);
     },
     init_page() {
       let vue = this;
       window.vx_set_room(vx, vue.$router.currentRoute.params.acc,
          vue.$router.currentRoute.params.uid);
       window.wss_open(vx, {
         acc: vx.room.acc,
         room: vx.room.name,
         uid: vx.user.id,
         routes_id: "quiz",
         routes: {         
           auth_me: function(msg) {
             if (vx.acc == vx.room.acc && vx.room.name == vx.user.my_room_name) {
               wss_send(vx, "auth_room", {"cred":vx.user.creds["myroom"]});
             } else {
               wss_send(vx, "auth_room", {});
             }
           },
           auth_room: function() { vue.do_list_room(); },
           room: function(msg) {
             if (vue.raise_blocked(msg.data)) { return; }
             vue.handle_new_join(msg.data);
             vue.do_list_room();
             vue.lower_check(msg.data);
           },
           list_room: vue.handle_list_room,
         }
       });
       if (vue.addlistener) {
         document.addEventListener("keydown", vue.handle_keypress);
         vue.addlistener = false;
       }
       vue.handle_list_room();
       vue.quiz_from_cookie();
     },
     handle_new_join(data) {
       if (data.k != "user_joined") { return; }
       wss_send(vx, "msg_to", {msg:"$no_lower", to:{uid:data.uid}});
     },
     quiz_into_cookie:function() {
       let vue = this;
       localStorage.setItem("quiz_cfg",JSON.stringify(vue.mastercfg));
       localStorage.setItem("quiz_score",JSON.stringify({s:vue.scores}));
     },
     quizpos_into_cookie:function() {
       let vue = this;
       let pos = {};
       pos.main_quest_idx = vue.main_quest_idx;
       pos.tb_quest_idx = vue.tb_quest_idx;       
       if (vue.use_tb) {
         pos.tb_quest_idx = vue.quest_idx;       
       } else {
         pos.main_quest_idx = vue.quest_idx;
       }
       localStorage.setItem("quiz_pos",JSON.stringify(pos));
     },
     quiz_from_cookie:function() {
       let vue = this;
       let cfg = window.to_json(localStorage.getItem("quiz_cfg"));
       vue.quest_idx = vue.main_quest_idx = vue.tb_quest_idx = 0;
       if (cfg && cfg.ques) {
         // eslint-disable-next-line
         console.log("CFG",scores);
         vue.mastercfg = cfg;
         if (!vue.mastercfg.points) {
           vue.mastercfg.points = 10;
         }
         if (!vue.mastercfg.timer) {
           vue.mastercfg.timer = 17;
         }
         vue.qrules = vue.mastercfg.rules;
         vue.use_tb = false;
         vue.quest = vue.mastercfg.ques;
         vue.cover.logo = vue.mastercfg.show.logo;
         vue.cover.title = vue.mastercfg.show.title;
         vue.cover.date = vue.mastercfg.show.date;
         vue.cover.host = vue.mastercfg.show.host;
         let pos = to_json(localStorage.getItem("quiz_pos"));
         if (pos) {
           // eslint-disable-next-line
           console.log("POS",scores);
           vue.main_quest_idx = pos.main_quest_idx || 0;
           vue.tb_quest_idx = pos.tb_quest_idx || 0;
           vue.quest_idx = vue.main_quest_idx;
         }
       }
       let scores = to_json(localStorage.getItem("quiz_score"));
       if (scores && scores.s) {
         // eslint-disable-next-line
         console.log("SCORES",scores.s);
         vue.scores = scores.s;
       }
       vue.refresh_players();
       vue.update_leaders();
     },
     handle_keypress: function(et) {
       let vue = this;
       if (et.isComposing || et.keyCode === 229) {
         return;
       }     
       //console.log(et.key);
       if (vue.mode == "qa") {
         if (et.key == "l" || et.key == "L") {
           vue.refreshSelf();
           if (vue.leaderboard && vue.leaderboard.length) {
             vue.mode = "lb";
           }
         } else if (et.key == "x" || et.key == "X") {
           vue.mode = "rules";
         } else if (et.key == "ArrowRight") {
           if (vue.qa == "waiting") {
             vue.qa = "done";
             vue.end_ans_period();
           } else if (vue.qa == "done") {
             if (vue.quest_idx < (vue.quest.length-1)) {
               vue.quest_idx++;
               vue.qa = "none";
               vue.do_lower_hand_all();
               vue.refresh_players();
             }
           } else {
             vue.qa = "waiting";
             vue.start_ans_period();
           }
         } else if (et.key == "ArrowLeft") {
           if (vue.qa == "waiting") {
             vue.qa = "none";
             vue.do_lower_hand_all();
           } else if (vue.qa == "none") {
             if (vue.quest_idx > 0) {
               vue.quest_idx--;
               vue.qa = "done";
               vue.refresh_players();
             }
           } else {
             vue.qa = "waiting";
           }
         } else if (et.key == "0") {
           vue.quest_idx = 0;
           vue.qa = "none";
           vue.do_lower_hand_all();
           vue.refresh_players();
         }
         vue.quizpos_into_cookie();
       } else if (vue.mode == "lb") {
         if (et.key == "l" || et.key == "L") {
           vue.mode = "qa";
         }
       } else if (vue.mode == "rules") {
         if (et.key == "x" || et.key == "X") {
           vue.mode = "qa";
         }
       }
       if (et.key == "q" || et.key == "Q") {
         if (!vue.mastercfg.tbques) { return; }
         if (vue.use_tb) {
           vue.use_tb = false;
           vue.tb_quest_idx = vue.quest_idx;
           vue.quest = vue.mastercfg.ques;
           vue.quest_idx = vue.main_quest_idx;
         } else {
           vue.use_tb = true;
           vue.main_quest_idx = vue.quest_idx;
           vue.quest = vue.mastercfg.tbques;
           vue.quest_idx = vue.tb_quest_idx;
         }
         vue.qa = "none";
         vue.refresh_players();
       }
       if (et.key == "r" || et.key == "R") {
         vue.do_list_room();
       }
     },
     get_score: function(u) {
        let vue = this;
        for (let i=0; i<vue.scores.length; i++) {
          let s = vue.scores[i];
          if (s.uid == u.uid) {
             if (!s.d) { s.d = u.d; }
             return s;
          }
        }
        let s = {};
        s.d = u.d;
        s.uid = u.uid;
        s.r = 0;
        s.w = 0;
        s.wa = 0;
        s.rank = 0;
        s.ans = {};
        vue.scores.push(s);
        return s;
     },
     update_leaders: function() {
        let vue = this;
        let scores = vue.scores.sort(function(a,b){
          return ((b.r-b.w)-(a.r-a.w));
        });
        let rank = 1;
        let prev_diff;
        let same_rank = 0;
        let lb = [];
        for (let i=0; i<scores.length; i++) {
          let s = scores[i];
          let diff = s.r-s.w;
          if (diff > 0) {
             if (prev_diff && diff != prev_diff) {
               rank += same_rank;
               same_rank = 0;
             }
             s.rank = rank;
             prev_diff = diff;
             same_rank++;
             lb.push(s);
          } else if (s.r > 0 || s.w > 0) {
             s.rank = 0;
             lb.push(s);
          }
          if (lb.length >= 8) { break; }
        }
        //console.log(JSON.stringify(lb));
        vue.leaderboard = lb;
     },
     qa_ans:function(u,correct,auto) {
        let vue = this;
        let sc = vue.get_score(u);
        let qid = vue.quest[vue.quest_idx].qid;
        let worth = vue.quest[vue.quest_idx].worth||1;
        sc.ans = sc.ans || {};
        if (correct) {
          sc.r += worth;
          sc.ans[qid] = 1;
          u.ans = 1;
        } else {
          sc.w += worth;
          if (auto) { sc.wa += worth; }
          sc.ans[qid] = -1;
          u.ans = -1;
        }
        // eslint-disable-next-line
        console.log(JSON.stringify(sc));
        vue.update_leaders();
        vue.quiz_into_cookie();
     },
     qa_ans_undo:function(u) {
        let vue = this;
        let sc = vue.get_score(u);
        let qid = vue.quest[vue.quest_idx].qid;
        let worth = vue.quest[vue.quest_idx].worth||1;
        if (!sc || !sc.ans) { return; }
        if (sc.ans[qid] < 0) {
          sc.w -= worth;
        } else if (sc.ans[qid] > 0) {
          sc.r -= worth;
        }
        sc.ans[qid] = 0;
        u.ans = 0;
        vue.update_leaders();
     },
     refresh_players: function() {
       let vue = this;
       if (!vue.players) { return; }
       let qid = vue.quest[vue.quest_idx].qid;
       vue.players.forEach(function(p) {
         let sc = vue.get_score(p);
         if (sc && sc.ans && sc.ans[qid]) {
           p.ans = 1;
         } else {
           p.ans = 0;
         }
         if (sc && sc.rank) {
           p.rank = sc.rank;
         }
       });
     },
     delayed_raise(uid,ms) {
       if (ms <= 0) {
         wss_send(vx, "raise_hand", {tgt_uid: uid});
       } else {
         setTimeout(function() {
            wss_send(vx, "raise_hand", {tgt_uid: uid});
         }, ms);
       }
     },
     do_raise_leaders: function(u) {
       let vue = this;
       let cnt = 0;
       if (!vue.leaderboard) { return; }
       for (let i=0; i<vue.leaderboard.length; i++) {
         let u = vue.leaderboard[i];
         if (!u.rank || u.rank > 3) { return; }
         if (++cnt > 8) { return; }
         vue.delayed_raise(u.uid, (u.rank-1)*150);
       }
     },
     start_ans_period: function() {
       let vue = this;
       // eslint-disable-next-line
       console.log("START");
       vue.is_raise_allowed = true;
       window.clearTimeout(vue.qna_timer.tid);
       vue.qna_timer.val = vue.quest[vue.quest_idx].timer || vue.mastercfg.timer;
       vue.qna_timer.tid = window.setInterval(function() {
         if (--vue.qna_timer.val < 0 || !vue.is_raise_allowed) {
           vue.end_ans_period();
         } else {
           //console.log("CountDown:"+vue.qna_timer.val);
         }
       },1000);
     },
     end_ans_period: function() {
       let vue = this;
       // eslint-disable-next-line
       console.log("END");
       vue.is_raise_allowed = false;
       window.clearTimeout(vue.qna_timer.tid);
     },
     raise_blocked: function(data) {
       let vue = this;
       if (!data || !data.k || data.k != "user_raised") {
         return false;
       }
       if (!data.self) {
          return false;
       }
       if (vue.is_raise_allowed) {
          return false;
       }
       // eslint-disable-next-line
       console.log("RaiseBlocked "+data.uid);
       wss_send(vx, "lower_hand", {tgt_uid: data.uid});
       wss_send(vx, "msg_to", {msg:"Answer period closed.", to:{uid:data.uid}});
       return true;
     },
     lower_check: function(data) {
       let vue = this;
       if (!data || !data.k || data.k != "user_lowered") {
         return;
       }
       if (data.uid && data.self) {
          vue.qa_ans({uid:data.uid},false,true);
          wss_send(vx, "msg_to", {msg:"You lost a point for lowering your own hand.", to:{uid:data.uid}});
       }
     },
     do_lower_hand_all: function() {
       wss_send(vx, "lower_hand", {tgt_uid: "all"});
     },
     do_lower_hand: function(u) {
       wss_send(vx, "lower_hand", {tgt_uid: u.uid});
     },
     do_list_room: function() {
       window.wss_send(window.vx, "list_room", {limit:8});
     },
     handle_list_room: function(msg) {
       let vue = this;
       let players = [];
       if (true) {
         if (!wss_ishash(msg)) { return; }
         for (let i=0; i<msg.data.length; i++) {
           let it = msg.data[i];
           let p = {};
           if (it.kind != "inl") { continue; }
           p.uid = it.uid;
           p.d = it.dname;
           players.push(p);
           if (players.length >= 5) { break; }
        }
       } else {
         let dummy = [{d:"Erik V", uid:"1"},
                    {d:"Steve V", uid:"2"},
                    {d:"Jane Doe", uid:"5"},
                    {d:"Susan Buck", uid:"8"},
                    {d:"John Smith", uid:"9"}];
         dummy.forEach(function(u) {
           let p = {};
           p.d = u.d;
           p.uid = u.uid;
           players.push(p);
         });
       }
       vue.players = players;
       vue.refresh_players();
     },
     loadCfg:function() {
       let vue = this;
       let reader = new FileReader();
       reader.onload = function(e) {
         let contents = e.target.result;
         let dnum = 1;
         vue.mastercfg = to_json(contents);         
         vue.mastercfg.ques.forEach(function(q,idx) {
           q.qid = "m"+idx;
           if (q.a) {
             q.num = dnum++;
             q.worth = q.worth || 1;
           }
         });         
         vue.mastercfg.ques.forEach(function(q,idx) {
           q.max = dnum-1;
         });
         if (vue.mastercfg.tbques) {
           dnum = 1;
           vue.mastercfg.tbques.forEach(function(q,idx) {
             q.qid = "tb"+idx;
             if (q.a) {
               q.num = dnum++;
               q.worth = q.worth || 1;
            }
           });
           vue.mastercfg.tbques.forEach(function(q,idx) {
             q.max = dnum-1;
           });
         }
         if (vue.mastercfg.rules) {
           vue.mastercfg.rules.forEach(function(r,idx) {
             r.n = idx+1;
           });
           vue.qrules = vue.mastercfg.rules;
         }
         vue.use_tb = false;
         vue.quest = vue.mastercfg.ques;
         vue.quest_idx = vue.main_quest_idx = vue.tb_quest_idx = 0;
         vue.cover.logo = vue.mastercfg.show.logo;
         vue.cover.title = vue.mastercfg.show.title;
         vue.cover.date = vue.mastercfg.show.date;
         vue.cover.host = vue.mastercfg.show.host;
         if (!vue.mastercfg.points) {
           vue.mastercfg.points = 10;
         }
         if (!vue.mastercfg.timer) {
           vue.mastercfg.timer = 17;
         }
         vue.scores = [];
         vue.leaderboard = [];
         vue.refresh_players();
         vue.quiz_into_cookie();
         vue.quizpos_into_cookie();
       };
       reader.readAsText(vue.cfgfile);
     },
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>
.container {
  position:relative;
  /*height:90vh;*/
  max-width:90vw;
  padding:0;
}
.showtitle {
  font-size:3vw;
}
.showdate {
  font-size:2vw;
}
.showhost {
  font-size:2vw;
}
.quiz_questnum {
  font-size:2vw;
  text-align:center;
}
.quiz_topic {
  font-size:2.5vw;
  text-decoration:underline;
  font-weight: 600;
}
.quiz_worth {
  font-size:2.0vw;
  font-weight: 600;
  color: blue;
}
.quiz_timer {
  width: 3.9vw;
  height: 3.9vw;
  font-size:2.5vw;
  font-weight: 600;
  color: red;
  border: red solid 2px;
  border-radius: 50%;
}
.quiz_question {
  padding: 1rem 0 0 0;
  font-size:3.7vw;
  font-weight: 600;
}
.quiz_questionimg {
  max-height: 25vh;
}
.quiz_answer {
  color: #b0b000;
  font-size:4vw;
  letter-spacing: 0.2vw;
  font-weight: 600;
  text-shadow: -2px 2px 0 #000,2px 2px 0 #000,2px -2px 0 #000,-2px -2px 0 #000;
}
.quiz_answerimg {
  height: 20vh;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  padding: 10vh 0 0 0;
}
.quiz_note {
  font-size:2vw;
  font-style:oblique;
}
.leaderbd {
  padding: 2rem 0;  
  font-size:2.3vw;
}
.leaderbdsub {
  padding: 0 0 0 0.2rem;
  font-size:1.8vw;
}
.leaderbd_title {
  font-size:2.7vw;
  padding: 0 0 1rem 0;
  font-weight: 600;
  color: blue;
}
.btn_score {
  margin: 0 0.5rem;
  padding:0.1rem;
}
.shortcut {
  padding: 0 0 0 0.2rem;
  font-weight: 600;
  color:blue;  
}
.rules {
  /* padding: 2rem 0; */
}
.rules_title {
  font-size:2.7vw;
  padding: 0 0 1rem 0;
  font-weight: 600;
  color: blue;
}
.rules_num {
  font-size:1.75vw;
  font-weight: 600;
  color: blue;
}
.rules_rule {
  font-size:1.75vw;
}
</style>
